var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-map-pos-container"},[_c('tianditu-map-picker',{ref:"mapPicker",attrs:{"value":_vm.mapData,"mode":"inline","height":400,"zoom":16},on:{"input":_vm.handleInput,"position-change":_vm.handlePositionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }